import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var Subscriber = /*#__PURE__*/function () {
  function Subscriber(nextHandler, errorHandler) {
    _classCallCheck(this, Subscriber);
    _defineProperty(this, "closed", false);
    _defineProperty(this, "nextHandler", void 0);
    _defineProperty(this, "errorHandler", void 0);
    this.nextHandler = nextHandler;
    this.errorHandler = errorHandler;
  }
  _createClass(Subscriber, [{
    key: "next",
    value: function next(event) {
      return this.nextHandler(event);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "error",
    value: function error(_error) {
      if (this.errorHandler) {
        this.errorHandler(_error);
      } else {
        this.closed = true;
      }
    }
  }, {
    key: "complete",
    value: function complete() {
      this.closed = false;
    }
  }]);
  return Subscriber;
}();